// Saved changes to Step 1's steps, drawn over pathSteps.ts. Step 1 is read-only, so they
// are not polled. Mirrors src/inrange_agents/amazon_blueprint.py.
import { useQuery } from "react-query";

import { QK } from "../queryKeys";
import { useAgentsHttp } from "../useAgentsHttp";

export type BlueprintOwner = "inrange" | "amazon" | "third" | "both";
export type BlueprintSide = "inrange" | "amazon";

export interface BlueprintNeed {
  text: string;
  /** The clause behind it, e.g. "EUSDR 3.1.4"; "" where none. */
  source: string;
  /** Where it sits in its step's list, one of the categories Step 3 groups that step's
   * items by; absent where the step's list has none, or saved before categories were. */
  category?: string;
}

/** One change to the blueprint. A null field keeps the page's own value. */
export interface BlueprintEdit {
  step_id: string;
  /** "custom": a step someone added; "override": a change to one of the page's. */
  kind: "custom" | "override";
  title: string | null;
  detail: string | null;
  owner: BlueprintOwner | null;
  lane: string | null;
  chapter: number | null;
  /** The steps it waits on; replaces the page's own list when set. */
  deps: string[] | null;
  /** What it needs from Amazon; replaces the page's own list when set. */
  needs: BlueprintNeed[] | null;
  /** The step's bullet points; replaces the page's own when set. */
  subs: string[] | null;
  proposed_by: BlueprintSide | null;
  status: "proposed" | "agreed" | null;
  hidden: boolean;
  version: number;
  /** Absent for a viewer outside InRange. */
  updated_at?: string;
  updated_by?: string | null;
  /** Who suggested an added step and who agreed a proposed one, by sign-in email; null
   * where not recorded. */
  suggested_by?: string | null;
  suggested_at?: string | null;
  agreed_by?: string | null;
  agreed_at?: string | null;
}

export const useAmazonBlueprint = () => {
  const http = useAgentsHttp();
  return useQuery<BlueprintEdit[]>(
    [QK.amazonBlueprint],
    async () =>
      (
        await http<{ steps: BlueprintEdit[] }>(
          "/amazon-overview/blueprint/list",
          {},
        )
      ).steps,
    { staleTime: Infinity },
  );
};
